/*
 *  Copyright (C) 2007 Free Software Foundation, Inc. <https://fsf.org/>
 *  This file (constants.js) is part of LiteFarm.
 *
 *  LiteFarm is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  LiteFarm is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 *  GNU General Public License for more details, see <https://www.gnu.org/licenses/>.
 */

export const ADD_SALE = 'ADD_SALE';
export const SET_SALES_IN_STATE = 'SET_SALES_IN_STATE';
export const SET_CROP_SALES_IN_STATE = 'SET_CROP_SALES_IN_STATE';
export const DELETE_SALE = 'DELETE_SALE';
export const SET_SELECTED_SALE = 'SET_SELECTED_SALE';
export const GET_EXPENSE = 'GET_EXPENSE';
export const SET_EXPENSE = 'SET_EXPENSE';
export const SET_EXPENSE_TYPE = 'SET_EXPENSE_TYPE';
export const SET_EXPENSE_DETAIL_DATE = 'SET_EXPENSE_DETAIL_DATE';
export const SET_SELECTED_EXPENSE_TYPE = 'SET_SELECTED_EXPENSE_TYPE';
export const GET_FARM_EXPENSE_TYPE = 'GET_FARM_EXPENSE_TYPE';
export const ADD_EXPENSES = 'ADD_EXPENSES';
export const DELETE_EXPENSES = 'DELETE_EXPENSES';
export const ADD_REMOVE_EXPENSE = 'ADD_REMOVE_EXPENSE';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const UPDATE_SALE = 'UPDATE_SALE';
export const DELETE_EXPENSE = 'DELETE_EXPENSE';
export const SET_IS_FETCHING_DATA = 'SET_IS_FETCHING_DATA';

export const REVENUE_FORM_TYPES = {
  CROP_SALE: 'crop_sale',
  GENERAL: 'general',
};

export const LABOUR_ITEMS_GROUPING_OPTIONS = {
  EMPLOYEE: 'EMPLOYEE',
  TASK_TYPE: 'TASK_TYPE',
};
